module.exports = __webpack_public_path__ + "img/38c2c01a33c38ab63f9f44b1e087eb7a@2x.04c93f80.png";